import { mapGetters } from 'vuex'
import { getWorkTypeIdByName, workTypeName } from '@/scripts/consts'

export const setExcludeType = {
  data() {
    return {
      roleNames: {
        ModeratorNir: 'moderatorNir',
        ModeratorDiss: 'moderatorDiss',
        ModeratorGrantContest: 'moderatorGrantContest',
        ModeratorScientificEvent: 'moderatorScientificEvent'
      },

      excludeAllTypes: [
        getWorkTypeIdByName(workTypeName.Publication),
        getWorkTypeIdByName(workTypeName.Monography),
        getWorkTypeIdByName(workTypeName.PrePrint),
        getWorkTypeIdByName(workTypeName.Dissertation),
        getWorkTypeIdByName(workTypeName.Grant),
        getWorkTypeIdByName(workTypeName.Contest),
        getWorkTypeIdByName(workTypeName.Performance),
        getWorkTypeIdByName(workTypeName.Incalculation),
        getWorkTypeIdByName(workTypeName.StudentGuide),
        getWorkTypeIdByName(workTypeName.EducationalPublication),
        getWorkTypeIdByName(workTypeName.NirAccomplishment),
        getWorkTypeIdByName(workTypeName.PublicOrganizationParticipation),
        getWorkTypeIdByName(workTypeName.OverseasEvent),
        getWorkTypeIdByName(workTypeName.StateAward),
        getWorkTypeIdByName(workTypeName.CooperationInformation),
        getWorkTypeIdByName(workTypeName.WinningScientificCompetition),
        getWorkTypeIdByName(workTypeName.NirCompensationAgreement),
        getWorkTypeIdByName(workTypeName.ScientificPracticalEvent)
      ]
    }
  },

  computed: {
    ...mapGetters('user', [
      'isAdmin',
      'isModerator',
      'isModeratorNir',
      'isModeratorDiss',
      'isModeratorGrantContest',
      'isModeratorScientificEvent'
    ]),

    excludeTypesByRole() {
      return {
        [this.roleNames.ModeratorNir]: [
          getWorkTypeIdByName(workTypeName.PrePrint),
          getWorkTypeIdByName(workTypeName.Dissertation),
          getWorkTypeIdByName(workTypeName.NirAccomplishment),
          getWorkTypeIdByName(workTypeName.PublicOrganizationParticipation),
          getWorkTypeIdByName(workTypeName.OverseasEvent),
          getWorkTypeIdByName(workTypeName.StateAward),
          getWorkTypeIdByName(workTypeName.CooperationInformation),
          getWorkTypeIdByName(workTypeName.WinningScientificCompetition),
          getWorkTypeIdByName(workTypeName.NirCompensationAgreement),
          getWorkTypeIdByName(workTypeName.ScientificPracticalEvent)
        ],
        [this.roleNames.ModeratorDiss]: [
          getWorkTypeIdByName(workTypeName.Publication),
          getWorkTypeIdByName(workTypeName.Monography),
          getWorkTypeIdByName(workTypeName.Grant),
          getWorkTypeIdByName(workTypeName.Contest),
          getWorkTypeIdByName(workTypeName.Performance),
          getWorkTypeIdByName(workTypeName.Incalculation),
          getWorkTypeIdByName(workTypeName.StudentGuide),
          getWorkTypeIdByName(workTypeName.EducationalPublication),
          getWorkTypeIdByName(workTypeName.NirAccomplishment),
          getWorkTypeIdByName(workTypeName.PublicOrganizationParticipation),
          getWorkTypeIdByName(workTypeName.OverseasEvent),
          getWorkTypeIdByName(workTypeName.StateAward),
          getWorkTypeIdByName(workTypeName.CooperationInformation),
          getWorkTypeIdByName(workTypeName.WinningScientificCompetition),
          getWorkTypeIdByName(workTypeName.NirCompensationAgreement),
          getWorkTypeIdByName(workTypeName.ScientificPracticalEvent)
        ],
        [this.roleNames.ModeratorGrantContest]: [
          getWorkTypeIdByName(workTypeName.Publication),
          getWorkTypeIdByName(workTypeName.Monography),
          getWorkTypeIdByName(workTypeName.PrePrint),
          getWorkTypeIdByName(workTypeName.Dissertation),
          getWorkTypeIdByName(workTypeName.Grant),
          getWorkTypeIdByName(workTypeName.Contest),
          getWorkTypeIdByName(workTypeName.Performance),
          getWorkTypeIdByName(workTypeName.Incalculation),
          getWorkTypeIdByName(workTypeName.StudentGuide),
          getWorkTypeIdByName(workTypeName.EducationalPublication),
          getWorkTypeIdByName(workTypeName.OverseasEvent),
          getWorkTypeIdByName(workTypeName.CooperationInformation),
          getWorkTypeIdByName(workTypeName.WinningScientificCompetition),
          getWorkTypeIdByName(workTypeName.NirAccomplishment),
          getWorkTypeIdByName(workTypeName.ScientificPracticalEvent)
        ],
        [this.roleNames.ModeratorScientificEvent]: [
          getWorkTypeIdByName(workTypeName.Publication),
          getWorkTypeIdByName(workTypeName.Monography),
          getWorkTypeIdByName(workTypeName.PrePrint),
          getWorkTypeIdByName(workTypeName.Dissertation),
          getWorkTypeIdByName(workTypeName.Grant),
          getWorkTypeIdByName(workTypeName.Contest),
          getWorkTypeIdByName(workTypeName.Performance),
          getWorkTypeIdByName(workTypeName.Incalculation),
          getWorkTypeIdByName(workTypeName.StudentGuide),
          getWorkTypeIdByName(workTypeName.EducationalPublication),
          getWorkTypeIdByName(workTypeName.OverseasEvent),
          getWorkTypeIdByName(workTypeName.CooperationInformation),
          getWorkTypeIdByName(workTypeName.WinningScientificCompetition),
          getWorkTypeIdByName(workTypeName.NirAccomplishment),
          getWorkTypeIdByName(workTypeName.PublicOrganizationParticipation),
          getWorkTypeIdByName(workTypeName.StateAward),
          getWorkTypeIdByName(workTypeName.NirCompensationAgreement)
        ]
      }
    }
  },

  methods: {
    setExcludedType() {
      if (this.isAdmin || this.isModerator) {
        this.filters.setExcludedType([])
        return
      }

      const roleNamesForExcludeType = [
        { name: this.roleNames.ModeratorNir, active: this.isModeratorNir },
        { name: this.roleNames.ModeratorDiss, active: this.isModeratorDiss },
        { name: this.roleNames.ModeratorGrantContest, active: this.isModeratorGrantContest },
        { name: this.roleNames.ModeratorScientificEvent, active: this.isModeratorScientificEvent }
      ]
        .filter(role => role.active)
        .map(role => role.name)

      const resultExcludeType = []

      for (const workType of this.excludeAllTypes) {
        if (roleNamesForExcludeType.every(roleName => this.excludeTypesByRole[roleName].includes(workType))) {
          resultExcludeType.push(workType)
        }
      }

      this.filters.setExcludedType(resultExcludeType)
    }
  }
}
